// import $ from 'jquery';
import 'owl.carousel/dist/assets/owl.carousel.css!';
import 'owl.carousel';

class EffectDetails {

  constructor(){
    const $ = jQuery;
    this.slider  = $('[data-trigger="effect-details"]');
    this.trigger = document.querySelectorAll('[data-trigger="effect-zoom"]');
    this._init();
  }

  _init(){
    
    document.addEventListener('DOMContentLoaded', (event) => {

      if( this.slider[0] && this.trigger[0] ){
        
        this._buildSlider();

        for (let element of this.trigger) {
          element.addEventListener('click', ()=> this._moveSlider(element) );
        }

      };  

    });
  }

  _buildSlider(){
    this.slider.owlCarousel({
      items:                 1,
      nav:                   true,
      navText:               ['',''],
      dots:                  false,
      lazyLoad:              true,
      autoHeight:            true,
      // autoplay:           false,
      // autoplayTimeout:    5000,
      // autoplayHoverPause: false,
      // autoHeight:         false,
    });
  }

  _moveSlider(element){
    const position = element.getAttribute('data-index');
    if(position){
      this.slider.trigger('to.owl.carousel', [position, 0]);
    }
  }

}

export const effectDetails = new EffectDetails();